import { useEffect, useRef } from "react";
import { useChatStore } from "@/stores/useChatStore";
import { useLayoutStore } from "@/stores/useLayoutStore";

/**
 * モニターが新しく開始されたときだけ、下部ペインを開いてモニタータブを前面へ出す
 * (チャット切替直後の初回ロードでは前回一覧が無いため前面へ出さない)。
 */
export function useNewMonitorFocus(): void {
	const monitors = useChatStore((s) => s.monitors);
	const openBottomPaneTab = useLayoutStore((s) => s.openBottomPaneTab);

	const previousMonitorIdsRef = useRef<Set<string> | null>(null);
	useEffect(() => {
		const previous = previousMonitorIdsRef.current;
		previousMonitorIdsRef.current = monitors === null ? null : new Set(monitors.map((m) => m.id));
		if (monitors === null || previous === null) return;
		if (monitors.some((m) => !previous.has(m.id))) openBottomPaneTab("monitors");
	}, [monitors, openBottomPaneTab]);
}
